/**
 * Het hele scherm, in stukken. Elk venster staat in views/screens/.
 *
 * De volgorde telt: vensters die later komen liggen erbovenop, tenzij hun z-index
 * anders zegt. Verander de volgorde dus niet zomaar.
 */
import { css } from '../lib/render.jsx';
import Header from './screens/Header.jsx';
import Studio from './screens/Studio.jsx';
import Gallery from './screens/Gallery.jsx';
import Toast from './screens/Toast.jsx';
import Viewer from './screens/Viewer.jsx';
import Confetti from './screens/Confetti.jsx';
import Tip from './screens/Tip.jsx';
import Welcome from './screens/Welcome.jsx';
import Poll from './screens/Poll.jsx';
import Feature from './screens/Feature.jsx';
import DuoPick from './screens/DuoPick.jsx';
import AvatarEditor from './screens/AvatarEditor.jsx';
import LogoutConfirm from './screens/LogoutConfirm.jsx';
import DuoInvite from './screens/DuoInvite.jsx';
import DmCompose from './screens/DmCompose.jsx';
import DmInbox from './screens/DmInbox.jsx';
import Celebrate from './screens/Celebrate.jsx';
import Account from './screens/Account.jsx';
import Inbox from './screens/Inbox.jsx';
import Activity from './screens/Activity.jsx';
import Publish from './screens/Publish.jsx';
import Guestbook from './screens/Guestbook.jsx';
import ReqCompose from './screens/ReqCompose.jsx';
import ReqSent from './screens/ReqSent.jsx';
import Mod from './screens/Mod.jsx';
import PollForm from './screens/PollForm.jsx';
import Limits from './screens/Limits.jsx';
import Keys from './screens/Keys.jsx';
import DailyPicker from './screens/DailyPicker.jsx';
import Beestje from './screens/Beestje.jsx';
import BetaTesters from './screens/BetaTesters.jsx';
import SeenLog from './screens/SeenLog.jsx';
import Pin from './screens/Pin.jsx';
import Chat from './screens/Chat.jsx';
import ThemePopup from './screens/ThemePopup.jsx';
import ThemeList from './screens/ThemeList.jsx';
import Snake from './screens/Snake.jsx';
import Memory from './screens/Memory.jsx';
import Tamagotchi from './screens/Tamagotchi.jsx';
import Arcade from './screens/Arcade.jsx';
import Ketting from './screens/Ketting.jsx';
import Taskbar from './screens/Taskbar.jsx';

export default function Template({ v }) {
  return (
    <>
    {/* De taakbalk staat vast onderin. Het scherm houdt die strook vrij met een
        onderrand, zodat er nooit iets achter verdwijnt. */}
    <div style={{ "width": "100%", "height": "100dvh", "background": "var(--room)", "color": "var(--ink)", "display": "flex", "flexDirection": "column", "overflow": "hidden", "paddingBottom": "calc(" + v.taskbarH + "px + env(safe-area-inset-bottom, 0px))" }}>
      <Header v={v} />
      {/* De studio staat niet meer in deze kolom: op een computer is hij een venster
          en hoort hij bij de andere programmaatjes onderaan. Stonden ze hier samen,
          dan vochten twee broers met flex 1 1 auto om dezelfde ruimte. */}
      <Gallery v={v} />
      <Toast v={v} />
      <Viewer v={v} />
      <Confetti v={v} />
      <Tip v={v} />
      <Welcome v={v} />
      <Poll v={v} />
      <Feature v={v} />
    </div>
    <DuoPick v={v} />
    <AvatarEditor v={v} />
    <LogoutConfirm v={v} />
    <DuoInvite v={v} />
    <DmCompose v={v} />
    <DmInbox v={v} />
    <Celebrate v={v} />
    <Account v={v} />
    <Inbox v={v} />
    <Activity v={v} />
    <Publish v={v} />
    <Guestbook v={v} />
    <ReqCompose v={v} />
    <ReqSent v={v} />
    <Mod v={v} />
    <PollForm v={v} />
    <Limits v={v} />
    <Keys v={v} />
    <DailyPicker v={v} />
    <SeenLog v={v} />
    <BetaTesters v={v} />
    <Beestje v={v} />
    <Pin v={v} />
    {/* Een tint donkerder achter de vensters, voor focus. Vangt geen klikken; zie
        vensterDimStyle in logic/render-vals.js. */}
    {v.showVensterDim ? <div style={css(v.vensterDimStyle)} /> : null}
    <Chat v={v} />
    <ThemePopup v={v} />
    <ThemeList v={v} />
    <Snake v={v} />
    <Memory v={v} />
    <Arcade v={v} />
    <Studio v={v} />
    <Tamagotchi v={v} />
    <Ketting v={v} />
    {/* Als laatste, want de balk hoort over alles heen te liggen. */}
    <Taskbar v={v} />
    </>
  );
}
